<template>
  <div>
    <div v-if="$apollo.loading">
      <spinner />
    </div>
    <div v-else>
      <span v-if="status === 'SUCCESSFUL'">{{
        $t('paymentDone', 'The payment has already been made')
      }}</span>
      <div v-else>
        <div class="failed-payment-container">
          <div class="failed-payment-title-container">
            <div class="failed-back-to-event" @click="goBack">
              <img
                class="pagination-arrow"
                src="/assets/data-table-icons/arrow-left.svg"
                alt="Go left"
              >
              Natrag na događaj
            </div>
            <div class="failed-title">Plaćanje otakazano</div>
            <div class="failed-subtitle">Nažalost, vaše plaćanje nije dovršeno.</div>
          </div>

          <div class="failed-tips-container">
            <div class="failed-tips-title">Što možete učiniti dalje?</div>
            <div class="failed-tips-text">
              <p>
                💳   Provjerite stanje na računu ili podatke o kartici.
              </p>
              <p>🔁   Pokušajte ponovno izvršiti plaćanje.</p>
              <p>✅   Ne zaboravite autorizirati plaćanje putem vašeg internet bankarstva.</p>
              <p>📧   Ako se ovaj problem i dalje ponavlja, čak i nakon provjere s Vašom bankom, slobodno nam se obratite putem kontakt obrasca – rado ćemo pomoći.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from '../shared/spinner'
import { GET_EVENT_SETTINGS } from '../../graphql/event.graphql'
import { GET_ORDER } from '../../graphql/order.graphql'
import { updateOrder } from '../../http'

export default {
  name: 'canceled-payment',
  components: {
    Spinner,
  },
  props: {
    orderNumber: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      status: '',
      slug: undefined,
    }
  },
  apollo: {
    getOrder: {
      query: GET_ORDER,
      variables() {
        return {
          orderId: this.orderNumber,
        }
      },
      async result({ loading, data }) {
        if (!loading) {
          const {
            getOrder: { eventId, status },
          } = data
          this.status = status
          const {
            data: {
              getEvent: { slug },
            },
          } = await this.$apollo.query({
            query: GET_EVENT_SETTINGS,
            variables: {
              id: eventId,
            },
          })
          this.slug = slug
          await updateOrder(this.orderNumber, { status: 'FAILED' })
        }
      },
    },
  },
  methods: {
    goBack() {
      this.goTo(this.routes.shared.register, {
        eventSlug: this.slug,
        orderNumber: this.orderNumber,
        status: 'FAILED',
      })
    },
  },
}
</script>

<style scoped>
.failed-payment-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
  text-align: center; /* Optional, to center text */
}

.pagination-arrow {
  width: 6.5px;
  height: 11px;
  margin-right: 6px;
}

.failed-payment-title-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Align text and items to the left */
  text-align: left; /* Ensure text aligns left */
  width: 100%;
  max-width: 493px; /* Match tips container if you want same width */
}

.failed-back-to-event {
  font-family: Raleway;
  font-weight: 700;
  font-size: 18px;
  line-height: 120%;
  letter-spacing: 1.5%;
  text-transform: uppercase;
  margin-bottom: 24px;
  cursor: pointer;
}

.failed-title {
  font-family: Raleway;
  font-weight: 800;
  font-size: 28px;
  line-height: 120%;
  text-align: start;
}

.failed-subtitle {
  font-family: Source Sans Pro;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
  text-align: start;
  margin-top: 8px;
}

.failed-tips-container {
  background-color: #F5F5F5;
  border-radius: 16px;
  padding: 24px;
  margin: 24px auto 0;
  width: 100%;
  max-width: 493px;
  box-sizing: border-box;
  text-align: start;
}

.failed-tips-title {
  font-family: Raleway;
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  margin-bottom: 12px;
}

.failed-tips-text p {
  font-family: Source Sans Pro;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  margin-bottom: 0px;
  word-wrap: break-word;
}

/* Optional: Fine-tune for smaller devices */
@media (max-width: 480px) {
  .failed-title {
    font-size: 24px;
  }

  .failed-subtitle,
  .failed-tips-text p {
    font-size: 16px;
  }

  .failed-tips-title {
    font-size: 18px;
  }

  .failed-tips-container {
    padding: 16px;
  }
}
</style>
